import React, { useState, useEffect } from "react";
import MasterLeftPanel from "../include/MasterLeftPanel";
import Header from "../include/header";
import Footer from "../include/footer";
import Global from "../../APIConfig";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link, useNavigate } from 'react-router-dom';
import AuthUser from "../../AuthUser";
import MainLoader from "../Loaders/MainLoader";
import ListLoader from "../Loaders/ListLoader";
import CopyToClipboard from 'react-copy-to-clipboard';

import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

function ContactList() {
    let navigate = useNavigate();
    const { headers1, headers2, logout } = AuthUser();
    const [list, setList] = useState([]);
    const [Loading, setLoading] = useState(true);
    const [Subloading, setSubloading] = useState(false);

    const [show, setShow] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const handleClose = () => setShow(false);
    const handleShow = (item) => {
        setSelectedItem(item);  // set clicked item
        setShow(true);          // open modal
    };

    useEffect(() => {
        GetContactList();
    }, []);
    const GetContactList = () => {
        setSubloading(true);
        axios({
            method: 'post',
            url: Global.baseUrl + 'Contactlist',
            headers: headers1,
            data: {
            }
        })
            .then(function (response) {
                console.log("API Response", response);
                if (response.data.status == 200) {
                    var data = response.data.value;
                    setList(data);
                }
                else {
                    setList();
                }
                setSubloading(false);
                setLoading(false);
            })
            .catch(function (error) {
                if (error.response.status == 401) {
                    toast.error(error.response.statusText);
                    logout();
                    navigate('/');
                    window.location.reload();
                }
                setSubloading(false);
                setLoading(false);
                // console.log(error);
            });
    }

    const handleDelete = (id) => {
        if (window.confirm("Do You Really Want To Delete")) {
            axios({
                method: 'post',
                url: Global.baseUrl + 'DeleteContact',
                headers: headers1,
                data: {
                    id: id,
                }
            })
                .then(function (response) {
                    if (response.data.status == 200) {
                        toast.success(response.data.message);
                    }
                    else {
                        toast.error(response.data.message);
                    }
                })
                .catch(function (error) {
                    if (error.response.status == 401) {
                        toast.error(error.response.statusText);
                        logout();
                        navigate('/');
                        window.location.reload();
                    }
                    // console.log(error);
                });
        }
        GetContactList();
    }


    return (
        <>
            <MasterLeftPanel />
            <main className='home-section'>
                <Header />
                <ToastContainer />
                {Loading == true ? <MainLoader /> :
                    <>
                        <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                            <div class="d-block mb-4 mb-md-0">
                                <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
                                    <ol class="breadcrumb breadcrumb-dark breadcrumb-transparent">
                                        <li class="breadcrumb-item">
                                            <a href="#">
                                                <i class="bx bx-home text-primary-400 fs-6"></i>
                                            </a>
                                        </li>
                                        <li class="breadcrumb-item active" aria-current="page">Contact us</li>
                                    </ol>
                                </nav>
                                <div class="d-flex justify-content-between">
                                    <div class="">
                                        <button class="btn btn_nav btn-sm" type="button">
                                            <i class="bx bx-arrow-back "></i>
                                        </button>
                                    </div>
                                    <div class="ps-2 ">
                                        <h2 class="h4">All Contact us</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 col-md"></div>
                            <div class="col-12 col-md-4">
                                <div class="table-settings shipment_list" id="">
                                    <div class="row align-items-start g-2" >
                                        <div class="col col-md ">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <section class="data_table">
                            <div class="card card-body border-0 shadow table-wrapper table-responsive ">
                                <table class="table table-hover">
                                    <thead>
                                        <tr>
                                            <th class="border-gray-200">Name</th>
                                            <th class="border-gray-200">Email</th>
                                            <th class="border-gray-200">Subject</th>
                                            <th class="border-gray-200">Message</th>
                                            <th class="border-gray-200">Date</th>
                                        </tr>
                                    </thead>
                                    {Subloading == true && <ListLoader />}
                                    {list != undefined && list.length > 0 && Subloading == false ?
                                        <tbody>
                                            {list.map((item, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td><Button class="fw-normal text-capitalize" variant="primary" onClick={() => handleShow(item)} style={{ cursor: "pointer" }}>{item.name}</Button></td>
                                                        <td><span class="fw-normal">{item.email}</span></td>
                                                        <td><span class="fw-normal text-capitalize">{item.subject}</span></td>
                                                        <td><span class="fw-normal text-capitalize">{item.message.length > 50
                                                            ? item.message.substring(0, 20) + '...'
                                                            : item.message}</span></td>
                                                        <td><span class="fw-normal text-capitalize">{item.entry_date}</span></td>
                                                        <td>
                                                            <button onClick={() => handleDelete(item.id)} type="button" className="btn btn-gray-100 btn-sm" data-bs-toggle="tooltip" title="Delete"><i className="bx bx-x"></i></button>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                        :
                                        <tbody><tr><td colSpan={8} className="text-center text-danger"> Record Not Found </td></tr></tbody>
                                    }
                                </table>

                            </div>
                        </section>
                    </>
                }
                <Modal show={show} onHide={handleClose} style={{ wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}>
                    <Modal.Header closeButton>
                        <Modal.Title>{selectedItem?.subject || 'Modal heading'}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {selectedItem?.message || 'No message available.'}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Close
                        </Button>
                        {/* <Button variant="primary" onClick={handleClose}>
                            Save Changes
                        </Button> */}
                    </Modal.Footer>
                </Modal>
            </main>
        </>

    );
}
export default ContactList;